import React from 'react';
import { withTranslation } from 'react-i18next';
import { Box, IconButton, Typography } from '@mui/material';

import UserAvatar from '@components/UserAvatar';
import ParticipantStatusIcon from '@components/ParticipantStatusIcon';
import ButtonTooltip from '@core/dashboard/components/ButtonTooltip';
import { HandPalmIcon } from '@icons/HandPalm';

import { IRaisedHandParticipantItem } from './interfaces';
import { useStyles } from './styles';

const RaisedHandParticipantItem = ({
  participant,
  t: translate,
}: IRaisedHandParticipantItem) => {
  const classes = useStyles();
  const isParticipantOnline = !!participant?.roomId;

  return (
    <Box sx={classes.root} component="div">
      <Box sx={classes.rootPosition} component="div">
        <Box sx={classes.userAvatar}>
          <UserAvatar
            src={participant.avatarImage}
            sx={classes.avatar}
            name={participant.name || participant.email}
          />
          {isParticipantOnline && (
            <ParticipantStatusIcon
              isOnline={isParticipantOnline}
              sx={classes.statusIcon}
            />
          )}
        </Box>
        <Typography sx={classes.username}>
          {participant.name || participant.email}
        </Typography>
      </Box>

      <Box sx={classes.tools}>
        <ButtonTooltip title={translate('participantsModal.handRaised')}>
          <IconButton sx={classes.iconButton}>
            <HandPalmIcon sx={{ ...classes.icon, color: '#FFCC00' }} />
          </IconButton>
        </ButtonTooltip>
      </Box>
    </Box>
  );
};

export default withTranslation()(RaisedHandParticipantItem);
